import { Components } from '@mui/material';

const makeMuiStepper = (): Components['MuiStepper'] => ({
  defaultProps: { connector: null },
});

export default makeMuiStepper;
